export default __webpack_public_path__ + "static/media/creative-mob.c0755570.png";